// extracted by mini-css-extract-plugin
export default {"inbound_document_navbar_style":"hpO696l7bR1T4nUQaV3y"};